import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { authErrorLink, registerApolloClient } from '../Middleware/authErrorLink';
import { uploadLink } from '../Middleware/uploadLink';

if (process.env.NODE_ENV === 'production') {
    (globalThis as any).__DEV__ = false;
}

export const client = new ApolloClient({
    cache: new InMemoryCache({
        typePolicies: {
            ScrapingItem: { fields: { route: { merge: true } } },
            Admin: { fields: { permissions: { merge: false } } },
        },
    }),
    link: ApolloLink.from([authErrorLink, uploadLink]),
    credentials: 'include',
    headers: { 'Apollo-Require-Preflight': 'true' },
});

// Wire the client into the auth middleware so its refresh path can call
// client.query without a circular import.
registerApolloClient(client);
